import React from 'react';
import { FormattedMessage } from 'react-intl';

const HISTORY_COPY = {
  en: {
    kicker: 'Billing overview',
    subtitle: 'Track payments, verify pending transactions, and reopen checkout if you need to top up again.',
    available: 'Available',
    used: 'Used',
    emptyTitle: 'No payment history yet',
    emptyText: 'When you complete your first payment, the receipt and status will appear here.',
  },
  ru: {
    kicker: 'Платежи и баланс',
    subtitle: 'Отслеживайте платежи, проверяйте незавершённые транзакции и быстро открывайте пополнение снова.',
    available: 'Остаток',
    used: 'Использовано',
    emptyTitle: 'История платежей пока пуста',
    emptyText: 'После первого платежа здесь появятся записи, статусы и быстрые действия.',
  },
};

class PaymentsHistoryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        isRunningCall: false,
        error: "",
        text: "",
        payments: []
    };
  }

  componentDidMount() {
    this.props.eventToGAnalitycs("payment_history_show");
    this.getHistory();
  }
 
  getHistory = async () => {
    const topic = this.props.tinode.getMeTopic();  
    const query = topic.startMetaQuery().withDesc().build();
    query.desc.inchatgpttype = "paymentshistory";
    
    try {
      const result = await topic.getMeta(query);
      if (!result || result.desc.outchatgpt === "") {
        this.setError(this.props.intl.formatMessage({ id: "phistory.error" }) + " (1001)");
      } else {
        const text = result.desc.outchatgpt;
        this.setState({ payments: JSON.parse(text) });
        this.setIsRunningCall(false);
        console.log('Success:', result);
      }
    } catch (error) {
      console.error('Error:', error);
      this.setError(this.props.intl.formatMessage({ id: "phistory.error" }) + " (1001)");
      this.setIsRunningCall(false);
    } finally {
      this.setIsRunningCall(false);
    }
  }
 
  setIsRunningCall(value) {
    this.setState({ isRunningCall: value });
  }

  setError(value) {
    this.setState({ error: value });
  }

    getCopy() {
      const language = (this.props.intl?.locale || 'en').split(/[-_]/)[0];
      return HISTORY_COPY[language] || HISTORY_COPY.en;
    }

    formatDate(value) {
      return new Intl.DateTimeFormat(this.props.intl.locale || 'en', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(value));
    }

    renderService(service) {
      return service === 1 ? "YouKassa" : "---";
    }
  
    renderStatus(status) {
      const statusClass = {
        1: 'phistory-status--progress',
        2: 'phistory-status--success',
        3: 'phistory-status--warning',
        4: 'phistory-status--error',
      }[status] || '';

      switch (status) {
        case 1:
          return <span className={`phistory-status ${statusClass}`}><FormattedMessage id="status.inProgress" defaultMessage="In progress" /></span>;
        case 2:
          return <span className={`phistory-status ${statusClass}`}><FormattedMessage id="status.success" defaultMessage="Success" /></span>;
        case 3:
          return <span className={`phistory-status ${statusClass}`}><FormattedMessage id="status.canceled" defaultMessage="Canceled" /></span>;
        case 4:
          return <span className={`phistory-status ${statusClass}`}><FormattedMessage id="status.error" defaultMessage="Error" /></span>;
        default:
          return "---";
      }
    }


  
    renderTable() {
      const { payments } = this.state;
      if (payments.length > 0) {
        return (
          <div className="phistory-table-wrap">
            <table className="phistory-table">
              <thead>
                <tr>
                  <th><FormattedMessage id="table.date" defaultMessage="Date" /></th>
                  <th><FormattedMessage id="table.service" defaultMessage="Service" /></th>
                  <th><FormattedMessage id="table.cost" defaultMessage="Cost" /></th>
                  <th><FormattedMessage id="table.currency" defaultMessage="Currency" /></th>
                  <th><FormattedMessage id="table.tokens" defaultMessage="Tokens" /></th>
                  <th><FormattedMessage id="table.status" defaultMessage="Status" /></th>
                  <th><FormattedMessage id="table.action" defaultMessage="Action" /></th>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment, index) => (
                  <tr key={index}>
                    <td>{this.formatDate(payment.PayDate)}</td>
                    <td>{this.renderService(payment.Service)}</td>
                    <td>{payment.Cost}</td>
                    <td>{payment.Curr}</td>
                    <td>{payment.Tokens}</td>
                    <td>{this.renderStatus(payment.Status)}</td>
                    <td>
                      {payment.Status !== 2 ? (
                        <button className='secondary phistory-action' type="button" onClick={() => this.props.checkPayment(payment.Token, payment.Service,payment.Cost,payment.Curr )}>
                          <FormattedMessage id="button.checkStatus" defaultMessage="Check status" />
                        </button>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      } else {
        const copy = this.getCopy();
        return (
          <div className="phistory-empty">
            <i className="material-icons">receipt_long</i>
            <strong>{copy.emptyTitle}</strong>
            <p>{copy.emptyText}</p>
          </div>
        );
      }
    }
  

  render() {
    const copy = this.getCopy();
    const availableTokens = Math.max((this.props.Tokens || 0) - (this.props.TokensUsed || 0), 0);

    return (
      <div className='phistory-overlay'>
        <div className='phistory-container'>
            <div className="cancel">
                <a href="#" onClick={e => {e.preventDefault(); this.props.onCancel();}}><i className="material-icons gray">close</i></a>
            </div>
            <div className="token-modal-header">
            <div className="token-modal-kicker">{copy.kicker}</div>
            <h2>
                <FormattedMessage id="paymenthistory" defaultMessage="Payment history" description="Payment history" />
            </h2>
            <p>{copy.subtitle}</p>
          </div>

          <div className="phistory-summary-grid">
            <div className="phistory-summary-card">
              <span>{copy.available}</span>
              <strong>{availableTokens}</strong>
            </div>
            <div className="phistory-summary-card">
              <span>{copy.used}</span>
              <strong>{this.props.TokensUsed || 0}</strong>
            </div>
            <div className="phistory-summary-card phistory-summary-card--accent">
              <span><FormattedMessage id="tokens" defaultMessage="Tokens:" description="Tokens:"/></span>
              <strong>{this.props.Tokens || 0}</strong>
            </div>
          </div>

          {this.renderTable()}

          <div className="phistory-toolbar"  >
              <div className="phistory-toolbar-copy">
                <strong><FormattedMessage id="tokens" defaultMessage="Tokens:" description="Tokens:"/></strong>
                <span>{this.props.TokensUsed || 0} / {this.props.Tokens || 0}</span>
              </div>
              <button id='linkTopUp' className='primary phistory-topup-button' type="button"
                    onClick={() => { this.props.onCancel(); this.props.onAddTokens();}}>
                     <FormattedMessage id="topup" defaultMessage="Top up" description="Top up"/>
              </button>
                
              </div>

        </div>

       
            
             
            


      </div>
    );
  }
}

export default PaymentsHistoryComponent;
